import React, { FC } from 'react';
import cx from 'classnames';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Tomato03, Cauli, Milk03, Milk02, Tomato02 } from 'components/home/stamps';
import useCommonStyles from 'styles/common';

const useStyles = makeStyles((theme) => ({
	guideline: {
		display: 'flex',
		flexDirection: 'column',
		width: '-webkit-fill-available',
		maxWidth: 1085,
		padding: '36px 20px 10px  20px',
		textAlign: 'left',
		position: 'relative',
        [theme.breakpoints.down('xs')]: {
			padding: '36px 35px 0 35px',
			'& ul': {
				paddingLeft: 25
			}
		}
	},
	subTitle: {
		marginTop: 24,
        [theme.breakpoints.down('xs')]: {
			marginTop: 16,
		}
	}

}));


interface Props {
	rulesRef: React.RefObject<HTMLDivElement>;
}

const Guideline: FC<Props> = ({ rulesRef }) => {
	const classes = useStyles();
	const common = useCommonStyles();

	return (<div className={ cx(classes.guideline) } ref={rulesRef}>
		<Tomato03 style={{ top: 173, left: -85, width: 50, transform: 'rotate(-25deg)' }} />
		<Cauli style={{ top: 110, right: -140,  width: 90}} />
		
		<Milk03 className={common.displayInMobile} style={{ top: 15, right: 60, width: 28}} />
		<Milk02 className={common.displayInMobile} style={{ top: 340, left: 20, width: 28}} />
		<Tomato02 className={common.displayInMobile} style={{ top: 43, right: 20, width: 23, transform: 'rotate(28deg)'}} />

		<Typography variant="subtitle1">{`活動期間`}</Typography>
		<ul>
			<li>
				<Typography variant='body1'>
					{`發票登錄時間：2025年6月6日至2025年7月3日(四) 23:59止`}
				</Typography>
			</li>
		</ul>
		<Typography
			variant="body2"
			align="left"
			style={{ whiteSpace: 'pre-line' }}
		>
			{`* 時間判別以本活動網站系統為準
				* 得獎公布日期：預計2025年7月14日(一)當天公布`}
		</Typography>

		<Typography variant="subtitle1" className={classes.subTitle}>{`活動辦法`}</Typography>
		<ul>
			<li>
				<Typography variant='body1'>
					{`活動期間於全聯實體門市、小時達、大潤發實體及線上通路購買好侍指定商品任兩盒(需含一盒蕃茄燴飯料理塊或北海道白醬系列料理塊)，憑該筆購買發票(兩項指定商品發票不得分開)，在此活動網站登錄發票號碼，並填寫基本資料，即可獲得抽獎資格！`}
				</Typography>
			</li>
		</ul>
		<Typography
			variant="body2"
			align="left"
			style={{ whiteSpace: 'pre-line'}}
		>
			{`* 活動參加次數可累計，參與活動越多次，得獎機會越高！
			* 同一張發票號碼限登錄乙次，且僅有乙次得獎機會，重複登錄將取消參加資格。
			* 參加本活動者如未滿18歲(西元2007年6月5日以後出生)或未正確填寫資料，主辦單位將取消其參加及兌獎資格。
			* 個人資料僅限台灣好侍食品「2025 Masaの紅白洋食對決」發票登錄及線上投票活動使用。`}
		</Typography>
		<Typography variant="subtitle1" className={classes.subTitle}>{`活動指定購買商品`}</Typography>
		<ul>
			<li>
				<Typography variant='body1'>
					{`購買通路：全台全聯實體門市、`}
					<Link
						href="http://pxgo.net/3FNKi93"
						target="_blank"
						rel="noopener noreferrer"
						underline="always"
						color="inherit"
					>
						小時達
					</Link>
					{`、大潤發實體及線上通路`}
				</Typography>
			</li>
		</ul>
	</div>);
};

export default Guideline;
